import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError, formatPrice } from "../../lib/api";
import { ORDER_STATUSES } from "../../constants/site";

const COLOR = { nouvelle: "bg-blue-100 text-blue-800", en_attente_paiement: "bg-amber-100 text-amber-800", "payée": "bg-emerald-100 text-emerald-800", "traitée": "bg-indigo-100 text-indigo-800", "livrée": "bg-slate-200 text-slate-700", "annulée": "bg-red-100 text-red-700" };

export const AdminOrders = ({ onChange }) => {
  const [orders, setOrders] = useState([]);
  const load = () => api.get("/admin/orders").then((r) => setOrders(r.data));
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    try { await api.patch(`/admin/orders/${id}/status`, { status }); toast.success("Statut mis à jour"); load(); onChange(); }
    catch (err) { toast.error(formatApiError(err)); }
  };

  if (orders.length === 0) return <p data-testid="admin-orders-empty" className="text-sm text-slate-500">Aucune commande pour le moment.</p>;

  return (
    <div data-testid="admin-orders" className="space-y-4">
      {orders.map((o) => (
        <div key={o.id} data-testid={`admin-order-${o.id}`} className="border border-navy/10 bg-white p-6">
          <div className="flex flex-wrap items-start justify-between gap-4">
            <div>
              <p className="font-mono text-xs text-slate-400">#{o.id} · {new Date(o.created_at).toLocaleString("fr-FR")}</p>
              <p className="mt-1 font-display font-semibold text-navy">{o.customer.name} <span className="font-normal text-slate-500">· {o.customer.phone}</span></p>
              <p className="text-xs text-slate-500">{o.customer.address}, {o.customer.city} {o.customer.email && `· ${o.customer.email}`}</p>
            </div>
            <div className="flex items-center gap-3">
              <span className={`px-2.5 py-1 font-mono text-[11px] uppercase tracking-wider ${COLOR[o.status] || "bg-slate-100"}`}>{o.status.replace(/_/g, " ")}</span>
              <span className="px-2.5 py-1 font-mono text-[11px] uppercase tracking-wider bg-ice text-navy">{o.method}</span>
              <select data-testid={`admin-order-status-${o.id}`} value={o.status} onChange={(e) => setStatus(o.id, e.target.value)} className="border border-navy/15 bg-white px-2 py-1.5 text-sm">
                {ORDER_STATUSES.map((s) => <option key={s} value={s}>{s.replace(/_/g, " ")}</option>)}
              </select>
            </div>
          </div>
          <ul className="mt-4 divide-y divide-navy/5 text-sm">
            {o.items.map((i, k) => <li key={k} className="flex justify-between py-2"><span>{i.name} × {i.quantity}</span><span className="font-semibold">{formatPrice(i.price * i.quantity)}</span></li>)}
          </ul>
          <p className="mt-3 text-right font-display text-lg font-bold text-navy">{formatPrice(o.total)}</p>
        </div>
      ))}
    </div>
  );
};
